/**
 * Shared types for edge condition configuration.
 *
 * Condition types kept in sync with the backend enum in
 * benchling/pipelines/steps/models/pipeline_step_definition.py
 */

export enum EdgeConditionType {
  FILES_EXIST = 'FILES_EXIST',
}

export const CONDITION_TYPE_DISPLAY_NAMES: Record<EdgeConditionType, string> = {
  [EdgeConditionType.FILES_EXIST]: 'Files exist',
};

export interface EdgeCondition {
  type: EdgeConditionType;
}
